export const DEFAULT_BASE_URL = 'https://dubs-server-prod-9c91d3f01199.herokuapp.com/api/developer/v1';

export const DEFAULT_RPC_URL = 'https://api.mainnet-beta.solana.com';

export type DubsNetwork = 'devnet' | 'mainnet-beta';

export const NETWORK_CONFIG: Record<DubsNetwork, { baseUrl: string; rpcUrl: string; cluster: string }> = {
  'mainnet-beta': {
    baseUrl: DEFAULT_BASE_URL,
    rpcUrl: DEFAULT_RPC_URL,
    cluster: 'mainnet-beta',
  },
  devnet: {
    baseUrl: DEFAULT_BASE_URL,
    rpcUrl: 'https://api.devnet.solana.com',
    cluster: 'devnet',
  },
};
